var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconEarn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 72 72",
    fill: "none",
    role: "img",
    "aria-label": "Institution",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#00C6EA",
    strokeWidth: 3,
    strokeLinejoin: "round",
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 28 36 14l24 14"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 28v24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29 28v24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43 28v24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56 28v24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 52h48"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 58h52"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEarn);
export default __webpack_public_path__ + "static/media/icon-earn.ef672fcad8514d4016a50034e0c5582d.svg";
export { ForwardRef as ReactComponent };